import { styled } from 'styled-components';
import TableItem from '../../components/Table/TableItem';

export const FirstTableItem = styled(TableItem)`
  padding-left: 16px;
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  justify-content: flex-start;
`;

export const FirstItem = styled(TableItem)`
  padding-left: 16px;
  justify-content: flex-start;
  /* min-width: 200px; */
`;
export const LastTableItem = styled(TableItem)`
  padding-right: 18px;
  /* min-width: 100px; */

  justify-content: flex-end;
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
`;
export const TableItemCenter = styled(TableItem)`
  max-width: ${props => (props.$long ? '520px' : '250px')};
  width: ${props => (props.$long ? '520px' : '250px')};

  justify-content: flex-start;
`;
export const IconDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const TableRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
`;
export const TableContainer = styled.div`
  border-radius: 10px 10px 0px 0px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  min-height: 588px;
  width: 100%;

  overflow-x: auto;
`;

export const PageCountContainer = styled.div`
  border-radius: 0px 0px 10px 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  width: 100%;
  padding: 20px;
  overflow: auto;
`;

export const PageButton = styled.button`
  width: 26px;
  border-radius: 50%;
  height: 26px;
  border: none;
  background: transparent;
  font-family: 'Poppins-Medium';

  font-size: 14px;
  user-select: none;
  color: #000;
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;
export const StyledTd = styled.td`
  min-width: 150px;

  padding: 12px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;
export const StyledTh = styled.th`
  text-align: center;
`;
export const StyledTdAll = styled(StyledTd)``;

// export const LastTableItem = styled(StyledTd)`
//   text-align: right;

//   cursor: pointer;
//   &:active {
//     opacity: 0.6;
//   }
// `;

export const Container = styled.div`
  /* flex: 1; */
  display: flex;
  flex-direction: row;
  min-height: 100dvh;
  background-color: #faf5f6;
`;
// export const ContentContainer = styled.div`
//   width: 100%;

//   padding: 33px;
// `;

export const ContentContainer = styled.div`
  padding-bottom: 100px;
  padding-left: 265px;
  padding-right: 33px;
  width: 100%;
  @media (max-width: 800px) {
    padding-left: 33px;
    padding-top: 53px;
  }
`;
export const InboxContainer = styled.div`
  border-radius: 10px;
  background: #fff;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.04);
  display: flex;
  /* min-height: 697px; */
  min-height: 875px;
  flex-direction: column;
  gap: 4px;
  align-items: ${props => (props.$empty ? 'center' : 'flex-start')};
  justify-content: ${props => (props.$empty ? 'center' : 'flex-start')};

  width: 100%;

  overflow: auto;
`;
export const MessageContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 12px 16px;

  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  justify-content: space-between;
  align-items: center;
  /* flex-wrap: wrap; */
  gap: 40px;
`;
export const LeftSide = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: flex-start;

  max-width: 180px;
`;
export const Name = styled.span`
  font-size: 15px;
  font-family: 'Poppins-Medium';

  letter-spacing: -0.408px;
`;

export const Message = styled.div`
  font-size: 14px;
  justify-content: flex-start;
  font-family: 'Poppins-Regular';
  max-width: 420px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
export const IconContainer = styled.div`
  //min-width: 5%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  gap: 10px;

  max-width: 100px;
`;
export const PaginationContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 1.6rem 2.4rem;
  flex: 1;
`;

export const NoDataContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  flex: 1;
  align-items: center;
`;

export const NoDataTitle = styled.span`
  font-family: 'Poppins-SemiBold';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
`;

export const DetailsContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 600px;
  flex-wrap: wrap;
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const ButtonAccept = styled.button`
  display: flex;
  padding: 5px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 1.04%, rgba(0, 0, 0, 0.5) 100%), #262626;
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1);
  color: #fffdfc;
  text-align: justify;

  font-family: 'Poppins-Medium';
  font-size: 14px;
  line-height: 22px; /* 157.143% */
  letter-spacing: -0.408px;
  border: none;
  cursor: pointer;

  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ButtonReject = styled(ButtonAccept)`
  color: #be6a59;
  background: white;
  box-shadow: none;
`;

export const RejectedTitle = styled.span`
  color: #be6a59;
  font-family: 'Poppins-SemiBold';

  font-size: 16px;

  line-height: 22px; /* 137.5% */
  letter-spacing: -0.408px;
`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
